import { loan_quote } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function activateLoanQuote({ url: { service }, token }: IAPI) {
  return async function activateLoanQuote(
    quoteID: string,
    marketCountry: string
  ) {
    const url = new URL(`/loan-quote/${quoteID}/activate`, service);
    const response = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({
        MarketCountry: marketCountry,
      }),
    });
    if (!response.ok) {
      throw new Error(`Network response was not OK: ${response.status}`);
    }
    return (await response.json()) as loan_quote.LoanQuote;
  };
}
